import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { cn } from '@/lib/utils';
export function WatchNowButton(t0) {
  const $ = _c(6);
  const {
    href,
    className
  } = t0;
  const WatchLink = !href || href === "/browse" ? "a" : Link;
  const t1 = href ?? "/browse";
  let t2;
  if ($[0] !== className) {
    t2 = cn("inline-block rounded-md border border-christ-red bg-christ-red px-10 py-4 font-bold text-christ-white-900 text-lg uppercase leading-none tracking-wider transition-all duration-300 ease-in-out hover:opacity-80", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== WatchLink || $[3] !== t1 || $[4] !== t2) {
    t3 = <WatchLink href={t1} className={t2}>Watch Now</WatchLink>;
    $[2] = WatchLink;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}